export default "__VITE_ASSET__B31E6NFX__"